import { orderBy } from 'lodash-es';
export const ALL_CLIENT_TYPES = [
    'business',
    'individual'
];
export const ALL_CLIENT_STATUSES = [
    'active',
    'archived'
];
export function sanitizeFilterValues(values, validValues) {
    return validValues.filter((valid)=>values.includes(valid));
}
export function toClient(model) {
    var _model_owner;
    return {
        id: model.clientId(),
        name: model.name(),
        isSample: model.isSample(),
        // WHY: legacy clients predate clientType and arrive empty; tolerated only until ANCR-844 Phase 2 backfills it, then tighten to required.
        type: model.clientType() || undefined,
        status: model.status(),
        primaryContact: (_model_owner = model.owner()) !== null && _model_owner !== void 0 ? _model_owner : undefined,
        contactsCount: model.contactsCount(),
        archiveEligibility: model.archiveEligibility(),
        deleteEligibility: model.deleteEligibility(),
        isMultiVendorCustomer: model.isMultiVendorCustomer()
    };
}
export function clientStateKey(eligibility) {
    return eligibility.type === 'eligibleWithWarning' ? eligibility.eligibleWithWarning.warning : 'default';
}
export const eligibilityTooltipsTextsPath = 'client.dashboard.eligibilityTooltips';
export function eligibilityTooltipTitle(eligibility, action, texts) {
    if (eligibility.type !== 'notEligible') return undefined;
    if (action === 'delete') {
        return texts[eligibility.notEligible.reason].delete();
    }
    return texts.linkedToActiveAgreement.archive();
}
export function filterClients(param) {
    let { clients, searchTerm, statusFilter, typeFilter } = param;
    const trimmedSearch = searchTerm.trim().toLowerCase();
    return clients.filter((client)=>{
        var _client_primaryContact, _client_primaryContact1;
        const passesSearch = !trimmedSearch || client.name.toLowerCase().includes(trimmedSearch) || ((_client_primaryContact = client.primaryContact) === null || _client_primaryContact === void 0 ? void 0 : _client_primaryContact.name.toLowerCase().includes(trimmedSearch)) || ((_client_primaryContact1 = client.primaryContact) === null || _client_primaryContact1 === void 0 ? void 0 : _client_primaryContact1.email.toLowerCase().includes(trimmedSearch)) || false;
        const passesStatus = statusFilter.length === 0 || client.status != null && statusFilter.includes(client.status);
        const typeFilterMatchesAll = ALL_CLIENT_TYPES.every((type)=>typeFilter.includes(type));
        const passesType = typeFilter.length === 0 || (client.type == null ? typeFilterMatchesAll : typeFilter.includes(client.type));
        return passesSearch && passesStatus && passesType;
    });
}
export function sortClients(param) {
    let { clients, sortKey, sortDirection } = param;
    var _sortPropertiesByKey_sortKey;
    const sortPropertiesByKey = {
        clientName: [
            (c)=>c.name.toLowerCase()
        ],
        status: [
            (c)=>{
                var _c_status;
                return (_c_status = c.status) !== null && _c_status !== void 0 ? _c_status : '';
            },
            (c)=>c.name.toLowerCase()
        ],
        type: [
            (c)=>{
                var _c_type;
                return (_c_type = c.type) !== null && _c_type !== void 0 ? _c_type : '';
            },
            (c)=>c.name.toLowerCase()
        ],
        contacts: [
            (c)=>{
                var _ref;
                var _c_primaryContact;
                return ((_ref = (_c_primaryContact = c.primaryContact) === null || _c_primaryContact === void 0 ? void 0 : _c_primaryContact.name) !== null && _ref !== void 0 ? _ref : '').toLowerCase();
            },
            (c)=>c.name.toLowerCase()
        ]
    };
    const sortProperties = (_sortPropertiesByKey_sortKey = sortPropertiesByKey[sortKey]) !== null && _sortPropertiesByKey_sortKey !== void 0 ? _sortPropertiesByKey_sortKey : sortPropertiesByKey.clientName;
    const orders = sortProperties.map(()=>sortDirection);
    return orderBy(clients, sortProperties, orders);
}
